const nittyGritty = {
  newUserPassword: "2a534272-1b01-4f41-b8ba-f90c4ed15739",
  newUserDate: new Date("2000-01-01"),
  fundsGrantedTitle: "Funds Granted"
};

export { nittyGritty };
